import React from 'react';
import { LuPencil, LuTrash2 } from 'react-icons/lu';

import { TaxResidencyV2 } from '@ndvr/portfolio-api';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { formatDate } from 'utils';

interface TaxResidencyCardProps {
    residency: TaxResidencyV2;
    isActive?: boolean;
    showDeleteButton: boolean;
    onEdit: (residency: TaxResidencyV2, isActive: boolean) => void;
    onDelete: (e: React.MouseEvent, residency: TaxResidencyV2) => void;
}

export const TaxResidencyCard = ({
    residency,
    isActive = false,
    showDeleteButton,
    onEdit,
    onDelete,
}: TaxResidencyCardProps) => {
    const handleEdit = (e: React.MouseEvent) => {
        e.stopPropagation();
        onEdit(residency, isActive);
    };

    return (
        <Card key={residency.taxResidencyGUID} className="group relative border-b p-4">
            <div className="absolute top-2 right-2 flex gap-1 opacity-0 transition-opacity group-hover:opacity-100">
                <Button variant="ghost" size="icon" className="h-8 w-8" onClick={handleEdit}>
                    <LuPencil className="h-4 w-4 text-gray-500 hover:text-blue-600" />
                </Button>
                {showDeleteButton && (
                    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={(e) => onDelete(e, residency)}>
                        <LuTrash2 className="h-4 w-4 text-gray-500 hover:text-red-600" />
                    </Button>
                )}
            </div>
            <div className="text-cocoa-1000 font-medium">{residency.title.plainText}</div>
            <div className="text-sm text-gray-600">Postal Code: {residency.postalCode}</div>
            <div className="text-sm text-gray-600">Effective: {formatDate(residency.effectiveFrom)}</div>
        </Card>
    );
};
